import * as React from 'react';

type Props = {
    isLoading: boolean;
    isLoadingText?: string;
} & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export default class LoadingButton extends React.PureComponent<Props> {

    constructor(props: Props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    render() {
        const { onClick, isLoading, isLoadingText, ...otherProps } = this.props;
        return <button
            onClick={this.onClick}
            {...otherProps}
        >
            {this.props.isLoading ? isLoadingText || "Loading..." : this.props.children}
        </button>
    }

    private onClick(e: React.MouseEvent<HTMLButtonElement>) {
        if (!this.props.isLoading && this.props.onClick) {
            this.props.onClick(e);
        } else if (this.props.isLoading) {
            e.preventDefault(); // For type=submit
        }
    }
}
